import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { InfoScreenData } from '../../types/InfoScreenData';
import { bookingTypeClass } from '../../types/bookingType';

interface TimeRange {
  start: string;
  end: string;
  isFullDay: boolean;
}

@Component({
  selector: 'app-activity-table',
  imports: [CommonModule, MatTableModule],
  templateUrl: './activity-table.component.html',
  styleUrl: './activity-table.component.scss',
})
export class ActivityTableComponent {
  /** The row's class for its booking type — safe for a type the API sends as a number. */
  readonly typeClass = bookingTypeClass;
  dataSource = input.required<InfoScreenData[]>();
  displayedColumns = input<string[]>(['time', 'activity', 'location', 'title']);
  displayDate = input.required<Date>();

  getLocationString(element: InfoScreenData): string {
    if (!element.resourceParent) {
      return element.resource;
    }
    return `${element.resourceParent} / ${element.resource}`;
  }

  getTimeRange(element: InfoScreenData): TimeRange {
    const displayDate = this.displayDate();
    const startDate = new Date(element.start);
    const endDate = new Date(element.end);

    // Get date components for comparison (normalize to midnight)
    const displayDateMidnight = new Date(displayDate);
    displayDateMidnight.setHours(0, 0, 0, 0);

    const startDateMidnight = new Date(startDate);
    startDateMidnight.setHours(0, 0, 0, 0);

    const endDateMidnight = new Date(endDate);
    endDateMidnight.setHours(0, 0, 0, 0);

    // Check if start is before display date
    const startIsBeforeDisplayDate = startDateMidnight < displayDateMidnight;

    // Check if end is after display date (i.e., end date is different or later)
    const endIsAfterDisplayDate = endDateMidnight > displayDateMidnight;

    // If both conditions are true, it's a full day booking
    if (startIsBeforeDisplayDate && endIsAfterDisplayDate) {
      return {
        start: 'Hele dagen',
        end: '',
        isFullDay: true,
      };
    }

    // Build start time
    let startStr: string;
    if (startIsBeforeDisplayDate) {
      startStr = '00:00';
    } else {
      startStr = this.formatTime(startDate);
    }

    // Build end time
    let endStr: string;
    if (endIsAfterDisplayDate) {
      endStr = '00:00';
    } else {
      endStr = this.formatTime(endDate);
    }

    return {
      start: startStr,
      end: endStr,
      isFullDay: false,
    };
  }

  private formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
}
